import { render } from "./SAEInfraComponent.vue?vue&type=template&id=7637100e&scoped=true&ts=true"
import script from "./SAEInfraComponent.vue?vue&type=script&lang=ts"
export * from "./SAEInfraComponent.vue?vue&type=script&lang=ts"

import "./SAEInfraComponent.vue?vue&type=style&index=0&id=7637100e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7637100e"]])

export default __exports__